<div class="sidebar-page">
    <div class="sidebar-page-header">
        <sidebar-menu></sidebar-menu>
    </div>
    <div class="sidebar-page-body scroll">
        <router-outlet></router-outlet>
    </div>
</div>
